// AgentListingsPage.jsx

import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Card, CardContent, CardMedia, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchAgentListings, deleteListingById } from '../../../services/ListingService';
import AgentListingsPageStyles from './AgentListingPage.styles';

const AgentListingsPage = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); 
    const navigate = useNavigate();
    const agentId = 1; 

    useEffect(() => {
        const loadListings = async () => {
            try {
                const data = await fetchAgentListings(agentId);
                setListings(data);
            } catch (error) {
                setError('Failed to load listings');
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        loadListings();
    }, [agentId]);

    const handleEdit = (listingId) => {
        navigate(`/edit-listing/${listingId}`);
    };

    const handleDelete = async (listingId) => {
        if (window.confirm('Are you sure you want to delete this listing?')) {
            try {
                await deleteListingById(listingId);
                setListings(listings.filter((listing) => listing.id !== listingId));
            } catch (error) {
                console.error('Failed to delete listing', error);
                setError('Failed to delete listing');
            }
        }
    };

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <Box sx={AgentListingsPageStyles.container}>
            <Typography variant="h4" sx={AgentListingsPageStyles.title}>
                My Listings
            </Typography>
            <Grid container spacing={3}>
                {listings.map((listing) => (
                    <Grid item xs={12} sm={6} md={4} key={listing.id}>
                        <Card sx={AgentListingsPageStyles.card}>
                            <CardMedia
                                component="img"
                                height="140"
                                image={listing.image}
                                alt={listing.title}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {listing.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {listing.location} - {listing.price}
                                </Typography>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => handleEdit(listing.id)}
                                    sx={AgentListingsPageStyles.editButton}
                                >
                                    Edit
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => handleDelete(listing.id)}
                                    sx={AgentListingsPageStyles.deleteButton}
                                >
                                    Delete
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default AgentListingsPage;
